import React from 'react';
import { serviceAreas, additionalLocations } from '../data/mock';
import { Phone, Mail, Clock, MapPin } from 'lucide-react';

const ServiceAreas = () => {
  return (
    <section id="areas" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-blue-600 font-semibold tracking-wider uppercase text-sm">Coverage</span>
          <h2 className="text-4xl sm:text-5xl font-bold text-[#1a365d] mt-4 mb-6">
            Areas We <span className="text-blue-500">Service</span>
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            We proudly serve communities across Southern Ontario. Don't see your area? 
            Give us a call — we may still be able to help.
          </p>
        </div>

        {/* Service Area Cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {serviceAreas.map((area) => (
            <div
              key={area.id}
              className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 group"
            >
              {/* Header */}
              <div className="bg-[#1a365d] p-6 group-hover:bg-[#2d4a7c] transition-colors">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <MapPin className="h-5 w-5 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-white">{area.region}</h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className="space-y-4 mb-6">
                  <a 
                    href={`tel:${area.phone}`}
                    className="flex items-center space-x-3 text-gray-600 hover:text-[#1a365d] transition-colors group/link"
                  >
                    <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center group-hover/link:bg-blue-100 transition-colors">
                      <Phone className="h-5 w-5 text-blue-600" />
                    </div>
                    <span className="font-medium">{area.phone}</span>
                  </a>
                  <a 
                    href={`mailto:${area.email}`}
                    className="flex items-center space-x-3 text-gray-600 hover:text-[#1a365d] transition-colors group/link"
                  >
                    <div className="w-10 h-10 bg-blue-50 rounded-full flex items-center justify-center group-hover/link:bg-blue-100 transition-colors">
                      <Mail className="h-5 w-5 text-blue-600" />
                    </div>
                    <span className="text-sm">{area.email}</span>
                  </a>
                </div>

                <div className="border-t border-gray-100 pt-4">
                  <div className="flex items-center space-x-2 text-[#1a365d] font-semibold mb-3">
                    <Clock className="h-4 w-4" />
                    <span>Delivery Hours</span>
                  </div>
                  <div className="text-sm text-gray-500 space-y-1">
                    <p>{area.hours.weekday}</p>
                    <p>{area.hours.saturday}</p>
                    <p>{area.hours.sunday}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Locations */}
        <div className="bg-white rounded-2xl shadow-md p-8">
          <h3 className="text-2xl font-bold text-[#1a365d] mb-2 text-center">
            All Service Locations
          </h3>
          <p className="text-gray-500 text-center mb-8">Click on any location to get a quote for your area</p>
          
          <div className="grid md:grid-cols-3 gap-x-12 gap-y-2">
            {additionalLocations.map((column, colIndex) => (
              <ul key={colIndex} className="space-y-2">
                {column.map((location, index) => (
                  <li key={index}>
                    <button
                      onClick={() => {
                        const element = document.querySelector('#contact');
                        if (element) element.scrollIntoView({ behavior: 'smooth' });
                      }}
                      className="text-gray-600 hover:text-[#1a365d] hover:font-medium transition-all flex items-center space-x-2 group w-full text-left"
                    >
                      <span className="w-1.5 h-1.5 bg-blue-300 rounded-full group-hover:bg-[#1a365d] transition-colors"></span>
                      <span>{location}</span>
                    </button>
                  </li>
                ))}
              </ul>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreas;
